
/**
 * 设置回传时间
 */
import CmdReturnInterval from './CmdReturnInterval.vue';


export default CmdReturnInterval;